import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-lair",
    templateUrl: "./go-lair.component.html"
})


export class GoLairComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;

    constructor() {
        super(GO_COMPONENTS.LAIR);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-lair/go-lair.component.ts